import React, { useState, useEffect } from "react";
import { FaCheckCircle, FaTimesCircle, FaTimes } from "react-icons/fa";

function ProgressBar({ progressData }) {
  const [showPopup, setShowPopup] = useState(true);

  // Hide popup if progress is 100
  useEffect(() => {
    if (progressData?.progress === 100) {
      setShowPopup(false);
    }
  }, [progressData]);

  if (!progressData || !showPopup) return null;

  return (
    <div className="profile-pop-up-container">
      <div className="profile-pop-up">
        {/* Close button */}
        <button
          className="popup-close-btn"
          onClick={() => setShowPopup(false)}
        >
          <FaTimes />
        </button>

        <h4>Complete your Profile</h4>
        <br />
        <progress value={progressData.progress} max="100"></progress>
        <div className="progress-text">{progressData.progress}% completed</div>
        <br />

        <div className="progress-point row">
          <p className="col-md-6 mb-2">
            {progressData.basicFields ? (
              <FaCheckCircle color="#38c600" />
            ) : (
              <FaTimesCircle color="#c60000" />
            )}{" "}
            Basic Details Added
          </p>

          <p className="col-md-6 mb-2">
            {progressData.workExperience ? (
              <FaCheckCircle color="#38c600" />
            ) : (
              <FaTimesCircle color="#c60000" />
            )}{" "}
            Work Experience Added
          </p>

          <p className="col-md-6 mb-2">
            {progressData.education ? (
              <FaCheckCircle color="#38c600" />
            ) : (
              <FaTimesCircle color="#c60000" />
            )}{" "}
            Education Added
          </p>

          <p className="col-md-6 mb-2">
            {progressData.skills ? (
              <FaCheckCircle color="#38c600" />
            ) : (
              <FaTimesCircle color="#c60000" />
            )}{" "}
            Skills Added
          </p>

          <p className="col-md-6 mb-2">
            {progressData.resume ? (
              <FaCheckCircle color="#38c600" />
            ) : (
              <FaTimesCircle color="#c60000" />
            )}{" "}
            Resume Uploaded
          </p>
        </div>

        <br />
        {progressData.progress >= 20 ? (
          <a href="/jobseeker/profile" className="normalbtn">
            Complete Profile
          </a>
        ) : (
          <a href="/jobseeker/profile" className="normalbtn">
            Complete Profile
          </a>
        )}
      </div>
    </div>
  );
}

export default ProgressBar;
